// export const BASE_URI = process.env.REACT_APP_API_BASE_URL
//   ? process.env.REACT_APP_API_BASE_URL
//   : "http://localhost:4000";
// export const API_BASE_URI = process.env.REACT_APP_API_BASE_URL
//   ? process.env.REACT_APP_API_BASE_URL + "/api"
//   : "http://localhost:4000/api";
// export const BUILD =
//   process.env.NODE_ENV === "production" ? "production" : "development";
// export const APP_URL = "http://localhost:3000";

export const APP_URL = "https://allure.condigital.cloud";
export const BASE_URI = "https://allure.condigital.cloud";
export const API_BASE_URI = "https://allure.condigital.cloud/api";

// export const APP_URL = "https://cost-recognition.condigital.cloud";
// export const BASE_URI = "https://cost-recognition.condigital.cloud";
// export const API_BASE_URI = "https://cost-recognition.condigital.cloud/api";
